<div class="create-tenant-component">
  <div class="container"
       style="display: flex; flex-direction: row; gap: 10px; justify-content: center"
>

    <mat-card>
      <mat-card-title>
        <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;" *ngIf="!keyValid">Enter key</h2>
        <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;" *ngIf="keyValid">Create an account</h2>
      </mat-card-title>
      <mat-card-content>

        <form class="example-form" *ngIf="!keyValid">
          <mat-form-field class="example-full-width">
            <mat-label>Access key</mat-label>
            <input matInput type="text"  name="tenantManagerPassword" [(ngModel)]="password">
          </mat-form-field>
        </form>
        <form class="example-form" *ngIf="keyValid">
          <mat-form-field class="example-full-width">
            <mat-label>Name of Company Implementing Rizkly</mat-label>
            <input matInput

                   name="companyNameInput"
                   [(ngModel)]="companyName"
                   required>
          </mat-form-field>
        </form>
        <form class="example-form" *ngIf="keyValid">
          <mat-form-field class="example-full-width">
            <mat-label>Email Address</mat-label>
            <input matInput

                   name="emailAddress"
                   [(ngModel)]="tenantManagerEmailAddress"
                   required>
          </mat-form-field>
        </form>
        <form class="example-form" *ngIf="keyValid">
          <mat-form-field class="example-full-width">
            <mat-label>Role</mat-label>
            <mat-select
                        [(ngModel)]="role"
                        name="role"
                        (ngModelChange)="onRoleChanged($event)">
              <mat-option [value]="4096">Customer Administrator</mat-option>
              <mat-option [value]="2048">Advisor Admin</mat-option>
            </mat-select>
          </mat-form-field>
        </form>

        <!--div *ngIf='complianceAreas && complianceAreas.length' class="form-group" >
            <ul>
                <li *ngFor="let complianceArea of complianceAreas">
                    <mat-expansion-panel class="mat-expansion-demo-width" >
                        <mat-expansion-panel-header>
                                <mat-panel-title>Compliance area</mat-panel-title>
                                <mat-panel-description>{{complianceArea.name}}</mat-panel-description>
                        </mat-expansion-panel-header>

                        <mat-checkbox [(ngModel)]="complianceArea.checked"
                                        [ngModelOptions]="{standalone: true}"
                                        [checked]="allChecked(complianceArea)"
                                        [indeterminate]="someChecked(complianceArea.controlItems)"
                                        (change)="setAllChecked(complianceArea.controlItems, $event.checked)">
                                    {{complianceArea.name}}</mat-checkbox>
                        <ul>
                            <li *ngFor="let controlItem of complianceArea.controlItems">
                                <mat-checkbox
                                        [(ngModel)]="controlItem.checked"
                                        #tenantComboboxes
                                        [ngModelOptions]="{standalone: true}"
                                        [checked]="controlItem.checked"
                                        [value]="controlItem.controlItemId">{{controlItem.description}}</mat-checkbox>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                </li>
            </ul>
        </div-->
      </mat-card-content>
      <mat-card-actions>
        <div class="form-group" style="text-align: center">
          <button mat-raised-button [disabled]="loading" style="border-radius: 6px;" (click)="onCreate()"
                  *ngIf="keyValid">Create
          </button>
          <button mat-raised-button [disabled]="loading" style="border-radius: 6px;" (click)="onCheck()"
                  *ngIf="!keyValid">Check
          </button>
          <img *ngIf="loading"
               src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
          <button mat-raised-button style="border-radius: 6px;" [routerLink]="['/tenants']">Cancel</button>
        </div>
        <div style="text-align: center"><a href="https://www.rizkly.com/rizkly-terms-of-service/" rel="noopener" target="_blank">Terms of Service</a></div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
<div style="position: fixed; bottom: 20px; right: 20px; font-size: 12px; color: gray; z-index: 10000">{{tenantPermissionName}}</div>
